<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.92159 6.49265L1.56456 4.13563L3.92159 1.77861H6.27861V4.13563L3.92159 6.49265Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.22454 2.83659L5.22464 2.83485"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
